import { t } from "@lingui/macro";
import IndoorRouteSimulationImage from "@/assets/indoor_route_simulation.png";
import RecommendedWorkoutsImage from "@/assets/recommended_workouts.png";
import TrainingPlansImage from "@/assets/training_plans.png";
import SystmFullAccessImage from "@/assets/systm_full_access.png";
import AthleteProfileImage from "@/assets/athlete_profile_snail.png";
import TrainingProgressImage from "@/assets/training_progress.png";
import { useCallback, useEffect, useMemo, useState } from "react";
import { Carousel, SubscriptionCard } from "@WahooFitness/redesignr";
import { Box } from "@mui/material";

export type SubscriptionCard = {
  image?: string;
  imageAsset?: string;
  title: string;
  details: string;
};

function FeatureCarousel() {
  const cards: SubscriptionCard[] = useMemo(
    () => [
      {
        imageAsset: TrainingProgressImage,
        title: t`Keep track of your training.`,
        details: t`Training metrics that translate effort into clarity, helping you train smarter, recover better, and perform consistently.`,
      },
      {
        imageAsset: AthleteProfileImage,
        title: t`Discover your athletic abilities.`,
        details: t`Find out your strengths and weaknesses as an athlete and get tailored recommendations.`,
      },
      {
        imageAsset: SystmFullAccessImage,
        title: t`Premium access to Wahoo SYSTM app.`,
        details: t`Training app designed by sports science team includes structured training plans, and cross-training workouts library.`,
      },
      {
        imageAsset: RecommendedWorkoutsImage,
        title: t`Personalized workout recommendations.`,
        details: t`Workouts suggestions personalized to your recent training and how you’re feeling each day.`,
      },
      {
        imageAsset: TrainingPlansImage,
        title: t`Achieve your goals with a structured training plan.`,
        details: t`The Wahoo Sports Science team training plans provide structure and guidance to help you reach your goals.`,
      },
      {
        imageAsset: IndoorRouteSimulationImage,
        title: t`Ride or run outdoor routes indoors.`,
        details: t`Access to our indoor route simulator to take any outdoor activity inside.`,
      },
    ],
    []
  );

  // 600 is the sm width of the container;
  // /2 is to get the center ; 8 is to convert from px to spacing
  // Math.max to avoid negative values
  // +2 is to add the spacing of the card
  const calculateGutterSpacing = useCallback(
    () => Math.max((window.innerWidth - 600) / 2 / 8, 0) + 2,
    []
  );
  const [gutterSpacing, setGutterSpacing] = useState(calculateGutterSpacing());

  useEffect(() => {
    const handleResize = () => {
      setGutterSpacing(calculateGutterSpacing());
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [calculateGutterSpacing]);

  return (
    <Box display="flex" flexDirection="column" gap={2} pt={1}>
      <Carousel
        items={cards.map((card) => {
          return (
            <SubscriptionCard
              key={card.title}
              title={card.title}
              description={card.details}
              imageUrl={card.imageAsset}
              gutterSpacing={gutterSpacing}
            />
          );
        })}
        width="100%"
      />
    </Box>
  );
}

export default FeatureCarousel;
